import { IconButton } from "@mui/material";
import { IconEdit } from "@tabler/icons";

const DisabledEditIcon = () => (

        <IconButton size="small" disabled>
          <IconEdit size="1.1rem" />
        </IconButton>
  );

  export default DisabledEditIcon;
  